import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
var status = [{ ID: "O", Text: "Open" }, { ID: "H", Text: "Hold" }, { ID: "L", Text: "Ready To Commit Later" }];

const purposeType = [
    {
        ID: 'S',
        Text: 'Stock',
    },
    {
        ID: 'O',
        Text: 'OM Order',
    },
    {
        ID: 'U',
        Text: 'CA/GL/FA - Usage',
    },
    {
        ID: 'M',
        Text: 'EF - Maintenance Request',
    },
    {
        ID: 'E',
        Text: 'Inventory/Non-Inventery Usage by Equipment',
    },
]

const OpenRequisitionsTabResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "737596E4-5032-486D-A48F-9427F86125D6";
       const [currentLayout, setCurrentLayout]= useState("Default");
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="none" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <FilterRow visible={true} />
                <Column dataField="detailDateExpected" caption='Expected' dataType="date"></Column>
                <Column dataField="purpose" caption='Purpose'
                    lookup={{ dataSource: purposeType, valueExpr: 'ID', displayExpr: 'Text' }} cellRender={cellData => {
                        switch (cellData.value) {
                            case 'S':
                                return <span>Stock</span>;
                            case 'O':
                                return <span>OM Order</span>;
                            case 'U':
                                return <span>CA/GL/FA - Usage</span>;
                            case 'M':
                                return <span>EF - Maintenance Request</span>;
                            case 'E':
                                return <span>Inventory/Non-Inventery Usage by Equipment</span>;
                            default:
                                return <span>{cellData.value}</span>;
                        }
                    }}></Column>
                <Column dataField="referenceNumber" caption='Reference #' ></Column>
                <Column dataField="description" caption='Description' ></Column>
                <Column dataField="orderedByID" caption='Orderd By' ></Column>
                <Column dataField="vendorID" caption='Vendor' ></Column>
                <Column dataField="lotCode" caption='Lot' ></Column>
                <Column dataField="requiredQuantity" caption='Required' format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} dataType="number" ></Column>
                <Column dataField="orderedQuantity" caption='Ordered' dataType="number"
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }} ></Column>
                <Column dataField="unitCostOriginal" caption='Unit Price' dataType="number"
                    format={{
                        type: 'currency',
                        precision: 2,
                        currency: 'USD',
                        useGrouping: true
                    }} ></Column>
                <Column dataField="amount" caption='Amount' dataType="number"
                    format={{
                        type: 'currency',
                        precision: 2,
                        currency: 'USD',
                        useGrouping: true
                    }}   ></Column>

                <Column dataField="vendoritemcode" caption="Vendor Item Code" visible={false}></Column>
                <Column dataField="status" caption="Status" visible={false}
                    lookup={{ dataSource: status, valueExpr: 'ID', displayExpr: 'Text' }} cellRender={cellData => {
                        switch (cellData.value) {
                            case 'O':
                                return <span>Open</span>;
                            case 'H':
                                return <span>Hold</span>;
                            case 'L':
                                return <span>Ready To Commit Later</span>;
                            default:
                                return <span>{cellData.value}</span>;
                        }
                    }}></Column>
                <Column dataField="taxableflag" caption="Taxable Flag" visible={false}></Column>
                <Column dataField="expirationdate" caption="Expiration Date" dataType="date" visible={false}></Column>
                <Column dataField="daterequired" caption="Date Required" dataType="date" visible={false}></Column>
                <Column dataField="dateexpected" caption="Date Expected" dataType="date" visible={false}></Column>
                <Column dataField="datereceived" caption="Date Received" dataType="date" visible={false}></Column>
                <Column dataField="unitofmeasure" caption="Unit of Measure" visible={false}></Column>
                <Column dataField="unitcostoriginal" caption="Unit Cost Original" visible={false}></Column>
                <Column dataField="unitcostbackorder" caption="Unit Cost Backorder" visible={false}></Column>
                <Column dataField="itemdiscount" caption="Item Discount" visible={false}></Column>
                <Column dataField="detailflag" caption="Detail Flag" visible={false}></Column>
                <Column dataField="comment" caption="Comment" visible={false}></Column>
                <Column dataField="detailmessage" caption="Detail Message" visible={false}></Column>
                <Column dataField="referencenumber" caption="Reference Number" visible={false}></Column>
                <Column dataField="requisitionflag" caption="Requisition Flag" visible={false}></Column>
                <Column dataField="code1_LOT" caption="Code1 LOT" visible={false}></Column>
                <Column dataField="code2_LOT" caption="Code2 LOT" visible={false}></Column>
                <Column dataField="code3_LOT" caption="Code3 LOT" visible={false}></Column>
                <Column dataField="code4_LOT" caption="Code4 LOT" visible={false}></Column>
                <Column dataField="code5_LOT" caption="Code5 LOT" visible={false}></Column>
                <Column dataField="code6_LOT" caption="Code6 LOT" visible={false}></Column>
                <Column dataField="code7_LOT" caption="Code7 LOT" visible={false}></Column>
                <Column dataField="code8_LOT" caption="Code8 LOT" visible={false}></Column>
                <Column dataField="code9_LOT" caption="Code9 LOT" visible={false}></Column>
                <Column dataField="code10_LOT" caption="Code10 LOT" visible={false}></Column>

                <Column dataField="date1_LOT" caption="Date1 LOT" dataType="date" visible={false}></Column>
                <Column dataField="date2_LOT" caption="Date2 LOT" dataType="date" visible={false}></Column>
                <Column dataField="date3_LOT" caption="Date3 LOT" dataType="date" visible={false}></Column>
                <Column dataField="date4_LOT" caption="Date4 LOT" dataType="date" visible={false}></Column>
                <Column dataField="date5_LOT" caption="Date5 LOT" dataType="date" visible={false}></Column>
                <Column dataField="date6_LOT" caption="Date6 LOT" dataType="date" visible={false}></Column>
                <Column dataField="date7_LOT" caption="Date7 LOT" dataType="date" visible={false}></Column>
                <Column dataField="date8_LOT" caption="Date8 LOT" dataType="date" visible={false}></Column>
                <Column dataField="date9_LOT" caption="Date9 LOT" dataType="date" visible={false}></Column>
                <Column dataField="date10_LOT" caption="Date10 LOT" dataType="date" visible={false}></Column>

                <Column dataField="quantity1_LOT" caption="Quantity1 LOT" visible={false}></Column>
                <Column dataField="quantity2_LOT" caption="Quantity2 LOT" visible={false}></Column>
                <Column dataField="quantity3_LOT" caption="Quantity3 LOT" visible={false}></Column>
                <Column dataField="quantity4_LOT" caption="Quantity4 LOT" visible={false}></Column>
                <Column dataField="quantity5_LOT" caption="Quantity5 LOT" visible={false}></Column>
                <Column dataField="quantity6_LOT" caption="Quantity6 LOT" visible={false}></Column>
                <Column dataField="quantity7_LOT" caption="Quantity7 LOT" visible={false}></Column>
                <Column dataField="quantity8_LOT" caption="Quantity8 LOT" visible={false}></Column>
                <Column dataField="quantity9_LOT" caption="Quantity9 LOT" visible={false}></Column>
                <Column dataField="quantity10_LOT" caption="Quantity10 LOT" visible={false}></Column>

                <Column dataField="orderedquantity" caption="Ordered Quantity" visible={false}></Column>
                <Column dataField="backorderquantity" caption="Back Orderd" visible={false}></Column>
                <Column dataField="receivedquantity" caption="Received Quantity" visible={false}></Column>
                <Column dataField="userdefinedcomment" caption="User Defined Comment" visible={false}></Column>
                <Column dataField="itempriorityflag" caption="Item Priority Flag" visible={false}></Column>
                <Column dataField="reference1_LOT" caption="Reference1 LOT" visible={false}></Column>
                <Column dataField="reference2_LOT" caption="Reference2 LOT" visible={false}></Column>
                <Column dataField="reference3_LOT" caption="Reference3 LOT" visible={false}></Column>
                <Column dataField="reference4_LOT" caption="Reference4 LOT" visible={false}></Column>
                <Column dataField="reference5_LOT" caption="Reference5 LOT" visible={false}></Column>
                <Column dataField="reference6_LOT" caption="Reference6 LOT" visible={false}></Column>
                <Column dataField="reference7_LOT" caption="Reference7 LOT" visible={false}></Column>
                <Column dataField="reference8_LOT" caption="Reference8 LOT" visible={false}></Column>
                <Column dataField="reference9_LOT" caption="Reference9 LOT" visible={false}></Column>
                <Column dataField="reference10_LOT" caption="Reference10 LOT" visible={false}></Column>

                <Column dataField="foreignunitcost" caption="foreign Unit Cost" visible={false}></Column>
                <Column dataField="foreignamount" caption="Foreign Amount" visible={false}></Column>
                {/* <Column dataField="foreignunitcost" caption="%Foreign" visible={false}></Column> */}
                {/* <Column dataField="foreignamount" caption="%Germination" visible={false}></Column>
<Column dataField="foreignamount" caption="%Moisture" visible={false}></Column> */}
                <Column dataField="detailDateRequired" caption="Required Date" visible={false}></Column>

                <Toolbar>
                <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(OpenRequisitionsTabResult);